<template>
  <!--
  PRK 2LKM4LCLCB252
  -->
  
  <van-popover :placement="popOverPlacement" v-model:show="showPopoverBtnRef" :actions="actions" >
    <template #reference>
  
  <van-button @mouseover="showPopoverBtnRef = true" plain @mouseleave="showPopoverBtnRef = false"  @click="varShowPopUpPrkRef = true" class="btn-add-prk" size="small" type="primary">
    <van-icon name="plus" /> {{ $t('Référence') }} 
  </van-button>
  
  </template>
  </van-popover>
  
  <van-popup  closeable  v-model:show="varShowPopUpPrkRef" position="bottom" v-bind:class="{  van_popup_choose_gigamedia : envWebName == 'Site Gigamedia' , van_popup_choose_gigamedia : envWebName == 'Formulaire' , van_popup_choose_webshop : envWebName == 'Webshop' , van_popup_choose_customer : envWebName == 'CustomerCare GIGAMEDIA' }" >
  
   <h3 class="align-center">{{ $t('Ajouter une référence à la liste') }} </h3>
   <van-field   v-on:keyup.enter="addPrkRef" :disabled="LoadAddRefDisabled" v-model="refPrk" class="grand_label input_prk all_border_radius"  center :label=" $t('Référence') " placeholder="PRK 4LKM2LC...">
      <template #button>
        <van-button :disabled="LoadAddRefDisabled"  @click="addPrkRef"  size="small" type="primary"> {{  $t('Ajouter')  }} </van-button>
      </template>
    </van-field>
  
    <van-notice-bar class="all_border_radius m-t2" v-if="ErreurRef" color="#1989fa" background="#ecf9ff" left-icon="info-o">
      {{ $t('Référence non valide') }} 
  </van-notice-bar>
    <van-notice-bar class="all_border_radius m-t2" v-if="showMessageNoPrkNoGgm" color="#1989fa" background="#ecf9ff" left-icon="info-o">
      {{ $t('Une référence valide doit débuter par GGM_ ou PRK_') }} 
  </van-notice-bar>
  
  <van-notice-bar class="all_border_radius m-t2" v-if="showMessageLongueurMax" color="#1989fa" background="#ecf9ff" left-icon="info-o">
    {{ $t('long_non_stand') }}
  </van-notice-bar>
  
  <van-notice-bar class="all_border_radius m-t2 notice_transprk" v-if="showMessageTransPrk" color="#1989fa" background="#ecf9ff" left-icon="info-o">
    {{ $t('transforme PRK') }}
    <van-button class="m-l-10" @click="transformPrk"  size="small" type="success"> {{  $t('Remplacer')  }} </van-button>
  </van-notice-bar>
  
  <van-notice-bar class="all_border_radius m-t2" v-if="showMessageRefPrk" color="#1989fa" background="#ecf9ff" left-icon="info-o">
    {{ $t('Référence non valide') }} 
  </van-notice-bar>
  
  <van-notice-bar class="all_border_radius m-t2" v-if="showMessageCharactSpec" color="#1989fa" background="#ecf9ff" left-icon="info-o">
    {{ $t('Référence erreur charactere spec') }} 
  </van-notice-bar>
  
  <van-notice-bar class="all_border_radius m-t2" v-if="showMessageLongueurMin" color="#1989fa" background="#ecf9ff" left-icon="info-o">
    {{ $t('Longueur incorrecte') }}  
  </van-notice-bar>
  
  
    <Spinner style="margin-top: 90px;" v-if="LoadAddRefDisabled"/>
  
  </van-popup>
  
  
  
    <br/>
      </template>
      
      <script>
       import Spinner from '../../loader/Spinner.vue'
      export default {
        props: ['popOverPlacement'],
        components: {
          Spinner,
        },
        data() {
          return {
            actions : [
        { text: this.$t('Ajouter une référence à la liste') },
      ],
      showMessageCharactSpec : false ,
      showMessageNoPrkNoGgm : false ,
      showMessageLongueurMin : false ,
      showMessageLongueurMax : false ,
      showMessageTransPrk : false ,
      showMessageRefPrk : false ,
            ErreurRef : false ,
            LoadAddRefDisabled : false ,
            showPopoverBtnRef : false ,
            varShowPopUpPrkRef: false,
              refPrk : '' ,
              envWebName : false
  
          }
        },
        mounted(){
          this.envWebName = this.$store.state.storeGlobal.StoreEnvWeb
        },
        computed: {
      
        },
        created() {
         
            },
        methods:{
          transformPrk(){
            this.refPrk = "PRK" + this.refPrk.substr(3)
            this.addPrkRef()
            
          },
          async addPrkRef(){ 
            // expression régulière pour les lettres et les chiffres uniquement
            const regex = /^[a-zA-Z0-9\s]*$/;
                if (!regex.test(this.refPrk)) {
                  // afficher un message d'erreur ou empêcher l'ajout de la référence
                  this.showMessageCharactSpec = true
                  return;
            }
            
  
            
            /**
             * Gestion du nombre de caractére longueur de câble pour qu'il soit toujours egale à 3
             * Si 2 alor ajout 0 devant
             * si 1 ajout 00 devant nombre
             */
           let lastThreeChar = this.refPrk.substr(this.refPrk.length - 3);
           let lastTwoChar = this.refPrk.substr(this.refPrk.length - 2);
           let lastOneChar = this.refPrk.substr(this.refPrk.length - 1);
           //Si longueur n'est pas un nombre de 3C
           if (isNaN(lastThreeChar)) {
            // Si les deux derniers sont nombre
            if (!isNaN(lastTwoChar)) {
              lastThreeChar = "0" + lastTwoChar;
              this.refPrk = this.refPrk.substr(0, this.refPrk.length - 2) + lastThreeChar;
            }
            else{
              //Si seul le dernier est un nombre
              if (!isNaN(lastOneChar)) {
                lastThreeChar = "00" + lastOneChar;
              this.refPrk = this.refPrk.substr(0, this.refPrk.length - 1) + lastThreeChar;
              }
            }
           }
             
            this.showMessageCharactSpec = false
            this.ErreurRef = false
            this.LoadAddRefDisabled = true 
            this.showMessageLongueurMax = false
            this.showMessageNoPrkNoGgm = false
            this.showMessageLongueurMin = false
            this.showMessageTransPrk = false
            this.showMessageRefPrk = false
            var result = await this.globalFunctionPrePanier.ajoutPrkInPanier(this)
            if(result == "erreur prk"){
              this.LoadAddRefDisabled = false
              this.showMessageLongueurMax = true
            }
            else if(result == "erreur longueur max"){
              this.LoadAddRefDisabled = false
              this.showMessageLongueurMax = true
            }
            else if(result == "erreur no prk no ggm"){
              this.LoadAddRefDisabled = false
              this.showMessageNoPrkNoGgm = true
            }
            else if(result == "erreur ref prk"){
              this.LoadAddRefDisabled = false
              this.showMessageRefPrk = true
            }
            else if(result == "transformation prk"){
              this.LoadAddRefDisabled = false
              this.showMessageTransPrk = true
            }
            else if(result == "erreur longueur min"){
              this.LoadAddRefDisabled = false
              this.showMessageLongueurMin = true
            }
            else{
              this.refPrk = '',
              this.varShowPopUpPrkRef = false
              this.LoadAddRefDisabled = false 
            
            }
         
          
          },
        }
      
         
      }
      
      </script>
      
      <style>
      
      </style>
      
      